import { ApiResponse, ENDPOINTS, apiInstance } from '@/shared/api';
import { MetaResponse } from '@/shared/api';

// 최초 입장시 메타데이터 조회
export async function getMeta() {
  const url = ENDPOINTS.common.meta();

  const res = await apiInstance.get<ApiResponse<MetaResponse>>(url);
  if (!res.data) throw new Error('Failed to get meta');
  return res.data;
}
